import * as React from "react";

interface Props {
  viewBox?: string;
  color: string;
  size: string;
}

export const ProductCar = (props: Props) => (
  <svg
    width={props.size}
    height={props.size}
    viewBox={props?.viewBox}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M16.333 17.167H4.667V18a.833.833 0 0 1-.834.833H3A.833.833 0 0 1 2.167 18V9.667l2.066-4.824a1.667 1.667 0 0 1 1.534-1.01h9.466a1.667 1.667 0 0 1 1.532 1.01l2.068 4.824V18a.833.833 0 0 1-.833.833h-.833a.833.833 0 0 1-.834-.833v-.833Zm.834-5.834H3.833V15.5h13.334v-4.167ZM3.98 9.667h13.04L15.234 5.5H5.767L3.98 9.667H3.98Zm1.937 5a1.25 1.25 0 1 1 0-2.5 1.25 1.25 0 0 1 0 2.5Zm9.166 0a1.25 1.25 0 1 1 0-2.5 1.25 1.25 0 0 1 0 2.5Z"
      fill={props.color}
    />
  </svg>
);
